import {
  GET_STATES_BY_COUNTRY_ID_FAILURE,
  GET_STATES_BY_COUNTRY_ID_REQUEST,
  GET_STATES_BY_COUNTRY_ID_SUCCESS,
  REQUEST_DASHBOARD,
} from '../../../actionConstants';

import apiClient from '../../../apiClient';

export const getStatesByCountryId = (dispatch, countryId) =>
  dispatch({
    type: GET_STATES_BY_COUNTRY_ID_REQUEST,
    payload: apiClient.aux.getStates(countryId).then(
      (res) =>
        dispatch({
          type: GET_STATES_BY_COUNTRY_ID_SUCCESS,
          res,
          countryId,
        }),
      (err) =>
        dispatch({
          type: GET_STATES_BY_COUNTRY_ID_FAILURE,
          err,
        }),
    ),
  });

export const getDashboardInfo = (dispatch, withoutLoading) =>
  dispatch({
    type: REQUEST_DASHBOARD,
    withoutLoading,
    payload: apiClient.dashboard.get(),
  });
